module.exports = __webpack_public_path__ + "static/media/d3_gallery.b4d112aa.jpeg";